import * as fabric from 'fabric';
import { SnappableMixin } from './snappable';

export class SnappyText extends SnappableMixin(fabric.Textbox) {}
